export enum CellActionType {
  RunFailed = '[Cell] RunFailed',
  Idle = '[Cell] Idle',
  Select = '[Cell] Select',
  BeginEdit = '[Cell] BeginEdit',
  EndEdit = '[Cell] EndEdit',

  AddCell = '[Cell] Add',
  AddCellAndRun = '[Cell] AddCellAndRun',
  AddCellFailure = '[Cell] AddFailure',
  AddCellSuccess = '[Cell] AddSuccess',

  ClearCellOutput = '[Cell] Clear Output',

  FoldCell = '[Cell] Fold',
  AddToLayout = '[Cell] AddToLayout',
  AddToLayoutSuccess = '[Cell] AddToLayoutSuccess',
  AddToLayoutFailure = '[Cell] AddToLayoutFailure',
  RemoveFromLayout = '[Cell] RemoveFromLayout',
  RemoveFromLayoutViaBuilder = '[Cell] RemoveFromLayoutViaBuilder',
  RemoveFromLayoutFailure = '[Cell] RemoveFromLayoutFailure',
  RemoveFromLayoutSuccess = '[Cell] RemoveFromLayoutSuccess',
  UpdateVizTitle = '[Cell] UpdateVizTitle',
  UpdateVizTitleFailure = '[Cell] UpdateVizTitleFailure',
  UpdateVizSuccess = '[Cell] UpdateVizSuccess',

  EditCellContent = '[Cell] EditCellContent',
  MoveCell = '[Cell] MoveCell',
  MoveCellFailure = '[Cell] MoveCellFailure',
  UpdateCell = '[Cell] Update',
  UpdateCellFailure = '[Cell] UpdateFailure',
  UpdateCellSuccess = '[Cell] UpdateSuccess',

  ToggleFreezeCell = '[Cell] ToggleFreezeCell',
  ToggleFreezeCellFailure = '[Cell] ToggleFreezeCellFailure',
  UpdateContentType = '[Cell] UpdateContentType',
  UpdateContentTypeFailure = '[Cell] UpdateContentTypeFailure',

  DestroyCell = '[Cell] Destroy',
  DestroyCellFailure = '[Cell] DestroyFailure',
  DestroyCellSuccess = '[Cell] DestroySuccess',

  LoadNotebookCellsSuccess = '[Cell] LoadNotebookCellsSuccess',
  LoadNotebookCellsFailure = '[Cell] LoadNotebookCellsFailure',
  // TODO: this is just to load a cell token and notebook-viz flow can be simplified. https://app.asana.com/0/354739738185310/648512762148652
  LoadVizCellSuccess = '[Cell] LoadVizCellSuccess',
  LoadVizCellFailure = '[Cell] LoadVizCellFailure',

  LoadLayoutVisuals = '[Cell] LoadLayoutVisuals',
  StubLayoutVisuals = '[Cell] StubLayoutVisuals',
  PolledLayoutVisuals = '[Cell] PolledLayoutVisuals',
  LoadLayoutVisualsReady = '[Cell] LoadLayoutVisualsReady',
  LoadLayoutVisualsSuccess = '[Cell] LoadLayoutVisualsSuccess',
  LoadLayoutVisualsFailure = '[Cell] LoadLayoutVisualsFailure',
  LoadLayoutVisualsSkipped = '[Cell] LoadLayoutVisualsSkipped',
  LoadEmbeddedLayoutVisualsSuccess = '[Cell] LoadEmbeddedLayoutVisualsSuccess',

  ExportCellComplete = '[Cell] ExportCellComplete',
  ExportedCellDelete = '[Cell] ExportedCellDelete',
  ExportDataframeCompleted = '[Cell Export] ExportDataframeCompleted', // Used in CellExportEffects

  RefreshDataViewAfterCellUpdate = '[Cell] RefreshDataViewAfterCellUpdate', // Used in CellExportEffects
}
